<template>
  <div class="Settings">
    <div class="settingsContainer">
      <div class="dataView">
        <ul v-if="$root.$data.values.length > 0">
          <li v-for="value in $root.$data.values">
            {{ value }}
          </li>
        </ul>
        <p v-if="$root.$data.values.length == 0">Numbers will be displayed here</p>
      </div>
      <div class="formGroup">
        <label for="forceNumber">Force Number</label>
        <input type="text" id="forceNumber" name="forceNumber" v-model="forceNumber" />
      </div>
      <div class="formGroup">
        <label for="settingsTap">Taps to Open Settings</label>
        <input type="number" id="settingsTap" name="settingsTap" v-model="settingsTap" />
      </div>
      <div class="formGroup">
        <label for="separatorOperator">Separator Sign</label>
        <select name="separatorOperator" id="separatorOperator" style="border:solid 1px #000000" v-model="separatorOperator">
          <option v-for="option in separatorOperator_options" v-bind:value="option.value">
            {{ option.text }}
          </option>
        </select>
      </div>
      <div class="formGroup">
        <label for="forceNumberTap">Taps to Force Number</label>
        <input type="number" id="forceNumberTap" name="forceNumberTap" v-model="forceNumberTap" />
      </div>
    </div>
    <router-link to="/">
      <button class="close">Close</button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Settings',
  data() {
    return {
      forceNumber: '',
      settingsTap: 4,
      forceNumberTap: 4,
      separatorOperator: 'multiply',
      separatorOperator_options: [
        { text: 'Addition (+)', value: 'addition' },
        { text: 'Subtraction (-)', value: 'subtract' },
        { text: 'Multiply (x)', value: 'multiply' },
        { text: 'Divide (÷)', value: 'divide' },
      ],
    };
  },
  mounted() {
    const forceNumber = localStorage.getItem('forceNumber');
    const settingsTap = localStorage.getItem('minimumSettingsTap');
    const separatorOperator = localStorage.getItem('separatorOperator');
    const forceNumberTap = localStorage.getItem('forceNumberTap');

    this.forceNumber = forceNumber;
    this.settingsTap = window.Number.parseInt(settingsTap);
    this.separatorOperator = separatorOperator;
    this.forceNumberTap = window.Number.parseInt(forceNumberTap);
  },
  watch: {
    forceNumber() {
      localStorage.setItem('forceNumber', this.forceNumber);
    },
    settingsTap() {
      localStorage.setItem('minimumSettingsTap', this.settingsTap);
    },
    forceNumberTap() {
      localStorage.setItem('forceNumberTap', this.forceNumberTap);
    },
    separatorOperator() {
      localStorage.setItem('separatorOperator', this.separatorOperator);
    },
  },
};
</script>

<style>
.Settings {

}

.Settings .settingsContainer {
  height: calc(100vh - 45px);
  max-height: calc(100vh - 45px);
  overflow-y: scroll;
}

.Settings .settingsContainer .formGroup {
  padding: 10px;
  color: #000000;
  display: flex;
  justify-content: space-between;
}

.Settings .settingsContainer .formGroup input {
  border: solid 1px #aaaaaa;
  padding: 5px;
}

.Settings .settingsContainer .formGroup:nth-child(even) {
  background: #eeeeee;
}

.Settings .dataView {
  min-height: 50vh;
  font-size: 20pt;
}

.Settings .close {
  padding: 10px;
  border: solid 1px #000000;
  width: 100%;
  font-size: 15pt;
}
</style>



// WEBPACK FOOTER //
// src/components/Settings.vue